/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import { components, states } from '@glowingblue-orell-thalia-common';

const { HomePage } = components;
const { HomeDiscussionsState } = states;
import HomeReviews from '../components/HomeReviews';
import HomeReviewsLeaderboard from '../components/HomeReviewsLeaderboard';
import HomeRatingsLeaderboard from '../components/HomeRatingsLeaderboard';
import ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

export default function () {
	extend(HomePage.prototype, 'blockGroups', function (groups) {
		const blocks = new ItemList<Mithril.Children>();
		blocks.add('carousel', <HomeReviews params={{ filter: { home: true, isReview: true } }} showBtn={true} />);
		groups.add('reviews', blocks, 95);
	});

	extend(HomePage.prototype, 'leaderboardBlocks', function (blocks) {
		blocks.add('reviews-leaderboard', <HomeReviewsLeaderboard />, 20);
		blocks.add('ratings-leaderboard', <HomeRatingsLeaderboard />, 5);
	});

	extend(HomeDiscussionsState.prototype, 'requestParams', function (params) {
		if (!params.filter['isReview']) {
			params.filter['-isReview'] = true;
		}
	});
}
